<template>
    <!--弹窗-->
    <!-- <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    > -->
    <div>
        <div style="display:flex; width:680px;margin-left: 20px;">
            <el-form
                ref="form"
				width="680px"
                class="query-form"
                size="mini"
                label-width="100px"
                style="padding: 0 "
            >
                <el-form-item class="query-form-item acos" >
                    <div class="acosItem">
                        <span style="margin-left: 12px;">Auto-Acos：</span>
                        <el-input-number
                            v-model="formData.auto_acos"
                            size="mini"
                            style="width: 165px;margin-left: 10px;"
                            :min="0.00"
                			:max="1"
                			:step="0.01"
                            label="请输入auto_acos"
                        ></el-input-number>
                    </div>
                	<div class="acosItem">
                	    <span>Res-Acos：</span>
                	    <el-input-number
                	        v-model="formData.res_acos"
                	        style="width: 165px;margin-left: 10px;"
                			size="mini"
                	        :min="0.00"
                			:max="1"
                			:step="0.01"
                	        label="请输入Res-Acos"
                	    ></el-input-number>
                	</div>
                	<div class="acosItem">
                	    <span style="margin-left: 12px;">品牌-Acos：</span>
                	    <el-input-number
                	        v-model="formData.brand_acos"
                	    size="mini"
                	        style="width: 165px;margin-left: 10px;"
                	        :min="0.00"
                			:max="1"
                			:step="0.01"
                	        label="请输入品牌-Acos"
                	    ></el-input-number>
                	</div>
                	<div class="acosItem">
                	    <span>Asin-Acos：</span>
                	    <el-input-number
                	        v-model="formData.asin_acos"
                	        style="width: 165px;margin-left: 10px;"
                	    size="mini"
                	        :min="0.00"
                			:max="1"
                			:step="0.01"
                	        label="请输入Asin-Acos"
                	    ></el-input-number>
                	</div>
                	<div class="acosItem">
                	    <span style="margin-left: 12px;">Skag-Acos：</span>
                	    <el-input-number
                	        v-model="formData.skag_acos"
                	    size="mini"
                	        style="width: 165px;margin-left: 10px;"
                	        :min="0.00"
                			:max="1"
                			:step="0.01"
                	        label="请输入Skag-Acos"
                	    ></el-input-number>
                	</div>

                	<div class="acosItem">
                	    <span>Skag-Tos-Acos：</span>
                	    <el-input-number
                	        v-model="formData.skag_tos_acos"
                	        style="width: 165px;margin-left: 10px;"
                	    size="mini"
                	        :min="0.00"
                			:max="1"
                			:step="0.01"
                	        label="请输入Skag-Tos-Acos"
                	    ></el-input-number>
                	</div>
                	<div class="acosItem">
                	    <span style="margin-left: 12px;">Skag-Ros-Acos：</span>
                	    <el-input-number
                	        v-model="formData.skag_ros_acos"
                	    size="mini"
                	        style="width: 165px;margin-left: 10px;"
                	        :min="0.00"
                			:max="1"
                			:step="0.01"
                	        label="请输入Skag-Ros-Acos"
                	    ></el-input-number>
                	</div>

                	<div class="acosItem">
                	    <span>长尾-Acos：</span>
                	    <el-input-number
                	        v-model="formData.changwei_acos"
                	        style="width: 165px;margin-left: 10px;"
                	    size="mini"
                	        :min="0.00"
                			:max="1"
                			:step="0.01"
                	        label="请输入长尾-Acos"
                	    ></el-input-number>
                	</div>
                	<div class="acosItem">
                	    <span style="margin-left: 12px;">腰部-Acos：</span>
                	    <el-input-number
                	        v-model="formData.yaobu_acos"
                	    size="mini"
                	        style="width: 165px;margin-left: 10px;"
                	        :min="0.00"
                			:max="1"
                			:step="0.01"
                	        label="请输入腰部-Acos"
                	    ></el-input-number>
                	</div>
                    <div class="acosItem">
                	    <span style="margin-left: 12px;">捡漏-Acos：</span>
                	    <el-input-number
                	        v-model="formData.jianlou_acos"
                	    size="mini"
                	        style="width: 165px;margin-left: 10px;"
                	        :min="0.00"
                			:max="1"
                			:step="0.01"
                	        label="请输入腰部-Acos"
                	    ></el-input-number>
                	</div>
                </el-form-item>
            </el-form>

        </div>

        <el-form>
            <div style="margin-top:17px; width: 50%; padding-bottom: 40px">
                <el-button
                    style="float:right;margin-left:6px;"
                    size="mini"
                    type="danger"
                    plain
                    @click="handleClose()"
                    >取 消</el-button
                >
                <el-button
                    style="float:right"
                    size="mini"
                    type="primary"
                    @click="submitForm"
                    >确定</el-button
                >
            </div>
        </el-form>
        <!-- <el-row style=" text-align: center;">
            <el-button
                style="width:90%;margin:auto"
                @click="addList"
                size="mini"
                type="primary"
                >添加sku</el-button
            >
        </el-row> -->
    </div>
    <!-- </el-dialog> -->
</template>
<script>
import * as api from "@/api/statistics/statistics";

export default {
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        us_arr: {
            type: Array,
            default: () => []
        },
        state: String,
        asin: Number
    },
    data() {
        return {
            limitUpload: 1,
            obj: {},
            loading: false,
            fileList: [],
            dateArr: [],
            listData: {},
            list: [],
            ad_group_name: "",
            ad_group_no: "",

			formData: {
			    clicks: 20,
			    tower_acos: 0.9,
			    high_click_not_order: 0.8,
			    low_click_not_order: 0.95,
				auto_acos: 0,
				res_acos: 0,
				brand_acos: 0,
				asin_acos: 0,
				skag_acos: 0,
				skag_tos_acos: 0,
				skag_ros_acos: 0,
				changwei_acos: 0,
				yaobu_acos: 0,
                jianlou_acos: 0,
			}
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            const loading = this.$loading({
                lock: true,
                text: "查询中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            api.get_ad_default_acos({
                asin: this.$route.query.asin,
                state: this.$route.query.state
            })
                .then(res => {
                    this.formData = res.data;
                })
                .finally(() => {
                    loading.close();
                });
        },
        addList() {
            this.list.push({
                sku: "",
                asin: "",
                product_name: "",
                property: ""
            });
        },
        deleteRow(index) {
            this.list.splice(index, 1);
        },
        // 保存信息
        submitForm() {
            let force = 0;
            this.$confirm("是否确定上传 Acos 数据", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    force = 1;
                    this.update();
                })
                .finally(() => {
                    // this.update(force);
                });
        },
	    typeNumber(str) {
	        return Number(Number(str));
	        // return Number(Number(str).toFixed(2));
	    },
        // 保存信息
        update(force) {
            const loading = this.$loading({
                lock: true,
                text: "修改中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
			let formData = this.formData;
            const data = {
                asin: this.$route.query.asin,
                state: this.$route.query.state,
                auto_acos: this.typeNumber(formData.auto_acos),
                res_acos: this.typeNumber(formData.res_acos),
                brand_acos: this.typeNumber(formData.brand_acos),
                asin_acos: this.typeNumber(formData.asin_acos),
                skag_acos: this.typeNumber(formData.skag_acos),
                skag_tos_acos: this.typeNumber(formData.skag_tos_acos),
                skag_ros_acos: this.typeNumber(formData.skag_ros_acos),
                changwei_acos: this.typeNumber(formData.changwei_acos),
                yaobu_acos: this.typeNumber(formData.yaobu_acos),
                jianlou_acos: this.typeNumber(formData.jianlou_acos),
            };
            api.add_ad_default_acos(data)
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: "修改成功",
                            type: "success"
                        });
                        this.disabled = false;
                        this.handleClose(true);
                    } else {
                        this.disabled = false;
                        this.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                })
                .finally(() => {
                    loading.close();
                });
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.$emit("close-callback", isshow);
        },
        //上传Excel文件的处理方法
        handleChange(file, fileList) {
            if (fileList.length > 1) {
                this.fileList = [fileList[fileList.length - 1]];
            }
            this.fileTemp = file.raw;
            let extend = this.fileTemp.name.substring(
                this.fileTemp.name.lastIndexOf("."),
                this.fileTemp.name.length
            );
            if (this.fileTemp) {
                if (extend == ".xlsx" || extend == ".xls") {
                    this.importfxx(this.fileTemp);
                } else {
                    this.$message({
                        type: "warning",
                        message: "附件格式错误，请删除后重新上传!"
                    });
                }
            } else {
                this.$message({
                    type: "warning",
                    message: "请上传附件!"
                });
            }
        },
        //超过上载文件的最大数量限制如何删除文件
        handleRemove() {
            this.fileList = [];
            this.fileTemp = null;
            this.obj = {};
        },
        //超过最大上传文件数时的处理方法
        handleExceed() {
            this.$message({
                type: "warning",
                message: "超过上载文件的最大数量限制!"
            });
            return;
        },
        importfxx(obj) {
            const _this = this;
            // const inputDOM = this.$refs.inputer;
            // 通过DOM检索文件数据
            this.file = obj;
            var rABS = false; //通过DOMRead检索文件数据将文件作为二进制字符串读取
            var f = this.file;
            var reader = new FileReader();
            // if (!FileReader.prototype.readAsBinaryString) {
            FileReader.prototype.readAsBinaryString = function(f) {
                var binary = "";
                var rABS = false; //将文件作为二进制字符串读取
                // var pt = this;
                var wb; //读取完成的数据
                var outdata;
                var reader = new FileReader();
                reader.onload = function() {
                    var bytes = new Uint8Array(reader.result);
                    var length = bytes.byteLength;
                    for (var i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    //如果main.js中没有介绍，那么您需要在这里介绍它来解析excel
                    var XLSX = require("xlsx");
                    if (rABS) {
                        wb = XLSX.read(btoa(binary), {
                            //手动转换
                            type: "base64"
                        });
                    } else {
                        wb = XLSX.read(binary, {
                            type: "binary"
                        });
                    }
                    outdata = XLSX.utils.sheet_to_json(
                        wb.Sheets[wb.SheetNames[0]]
                    );
                    //数据可以在这里处理。
                    const arr = [];
                    outdata.map(v => {
                        const obj = {};
                        obj["sku"] = v["SKU"];
                        obj["product_name"] = v["品名"];
                        obj["asin"] = v["asin"];
                        obj["property"] =
                            (v["专有属性"] &&
                                String(v["专有属性"]).split("\n")) ||
                            [];
                        arr.push(obj);
                    });
                    _this.list = arr;
                    return arr;
                };
                reader.readAsArrayBuffer(f);
            };
            if (rABS) {
                reader.readAsArrayBuffer(f);
            } else {
                reader.readAsBinaryString(f);
            }
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.acos{
		margin-left: -155px;
		.acosItem{
			float: left;
			width:320px;
			text-align: right;
		}
	}
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
